import React from 'react'
import { ControllerProps } from 'react-hook-form'
import { TIME_INPUT_FORMAT } from 'transfix-ui/components/TimeInput'
import { Box } from 'transfix-ui/core'
import ControlledDatePicker, { IControlledDatePickerProps } from '../ControlledDatePicker'
import ControlledTimePicker, { IControlledTimeInputProps } from '../ControlledTimeInput'

const getInputName = (baseName: string, inputName: string): string => {
  return [baseName, inputName].join('.')
}

type IBaseControllerProps = ControllerProps<React.ComponentType<IControlledDatePickerProps>>

export interface IControlledDateAndTimeProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  DatePickerProps?: Partial<IControlledDatePickerProps['DatePickerProps']>
  TimeInputProps?: Partial<IControlledTimeInputProps['TimeInputProps']>
  dataTest?: string
  defaultValue?: {
    /**
     * @example '2022-05-22'
     */
    date?: string | null
    /**
     * @example '22:30'
     */
    time?: string
  }
}

export const ControlledDateAndTime = ({
  control,
  dataTest = 'ControlledDateAndTime',
  name,
  defaultValue,
  DatePickerProps = {},
  TimeInputProps = {},
}: IControlledDateAndTimeProps) => {
  const { date: defaultDate, time: defaultTime } = defaultValue || {}
  const dateName = getInputName(name, 'date')
  const timeName = getInputName(name, 'time')
  return (
    <Box display='flex' data-test={dataTest}>
      <Box width='132px' mr={1}>
        <ControlledDatePicker
          control={control}
          name={dateName}
          defaultValue={defaultDate}
          DatePickerProps={{
            ...DatePickerProps,
          }}
        />
      </Box>
      <ControlledTimePicker
        control={control}
        name={timeName}
        defaultValue={defaultTime}
        TimeInputProps={{
          timeFormat: TIME_INPUT_FORMAT.MILITARY,
          minuteIncrement: 15,
          ...TimeInputProps,
        }}
      />
    </Box>
  )
}

export default ControlledDateAndTime
